<div 
    appResponsiveAccount [displayAreaConfig]="displayAreaConfig"
    [ngClass]="{'mobileLoginSmall':router.url.includes('mobileLogin') === true }"
>
    <router-outlet></router-outlet>
</div>